import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PurchaseOrder } from '~v2Models/purchaseOrders.model';

@Component({
  selector: 'sa-lmo-active-purchase-orders-table',
  styleUrls: ['./lmo-active-purchase-orders-table.component.scss'],
  templateUrl: './lmo-active-purchase-orders-table.component.html',
})
export class LmoActivePurchaseOrdersTableComponent implements OnInit {
  public activeDataSource: MatTableDataSource<PurchaseOrder>;
  public displayedColumns = [
    'name',
    'mineName',
    'meshType',
    'costPerTon',
    'orderedToday',
    'totalAllocationUsed',
    'createdTimestamp',
    'expirationTime',
  ];
  @ViewChild(MatSort, { static: true }) public sort: MatSort;

  @Input() public set activePurchaseOrders(value: PurchaseOrder[]) {
    if (value) {
      this.activeDataSource.data = value;
    } else {
      this.activeDataSource.data = [];
    }
  }

  constructor() {
    this.activeDataSource = new MatTableDataSource([]);
  }

  public ngOnInit(): void {
    this.activeDataSource.sort = this.sort;
  }
}
